import { useEffect } from "react";
import { getEnvironmentConfig } from "@/config/domainConfigLoader";

// Ancien lien mail garant `/garant/sav` : la liste des SAV du garant vit sur
// l'outil pro V2 (/sav, authentifié externe).
export default function RedirectOutilsPro() {
  useEffect(() => {
    const proUrl = getEnvironmentConfig().PRO_URL_V2;
    if (!proUrl) {
      console.error("[RedirectOutilsPro] PRO_URL_V2 non configurée pour ce domaine : redirection vers l'outil pro impossible.");
      return;
    }
    const base = proUrl.replace(/\/+$/, "");
    setTimeout(() => {
      window.location.href = `${base}/sav`;
    }, 0);
  }, []);
  return null;
}
